import * as types from './types'

export function userLogout () {
  return {
    type: types.USER_LOGOUT
  }
}



// WEBPACK FOOTER //
// ./src/store/auth/actions.js